'use strict';exports.__esModule = true;var _extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reactRouter = require('react-router');

var _ = require('../../');

var _HeaderMobile = require('../HeaderMobile.scss');var styles = _interopRequireWildcard(_HeaderMobile);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var MobileMenuItem = function MobileMenuItem(properties) {var
  link = properties.link,iconName = properties.iconName,title = properties.title,additionalProps = properties.additionalProps,url = properties.url,leads = properties.leads,isNew = properties.isNew,translate = properties.translate;
  var isExternal = !!url;
  var Tag = isExternal ? 'a' : _reactRouter.Link;
  var to = isExternal ? undefined : link;
  var href = isExternal ? url : undefined;

  var renderNumberLeads = function renderNumberLeads() {
    if (leads < 100) {
      return (
        _react2.default.createElement('div', { className: styles.notViewed }, leads));

    }

    return (
      _react2.default.createElement('div', { className: styles.notViewed }, '+99'));

  };

  return (
    _react2.default.createElement(Tag, _extends({ to: to, href: href }, additionalProps),
      _react2.default.createElement('div', { className: styles.menuItem },
        _react2.default.createElement('div', { className: styles.itemIcon },
          _react2.default.createElement('span', { className: 'icon icon-' + iconName },
            _react2.default.createElement('span', { className: 'path1' }),
            _react2.default.createElement('span', { className: 'path2' }),
            _react2.default.createElement('span', { className: 'path3' }))),


        _react2.default.createElement('div', { className: styles.itemTitle },
          translate('header', title)),

        title === 'leads' && leads && renderNumberLeads(),
        isNew &&
        _react2.default.createElement('div', { className: styles.newWrapper }, '\xA0\xA0',
          _react2.default.createElement(_.OMLabelNew, {
            label: translate('iconTitles', 'newPropertyLabel'),
            color: '#FF8479' })))));





};exports.default =

MobileMenuItem;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/HeaderComponents/MobileMenuItem.js
// module id = 2672
// module chunks = 0